module.exports = __webpack_public_path__ + "static/media/back.b5fb2b05.jpg";